import Head from 'next/head';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import { NextSeoProps } from 'next-seo/lib/types';

import METADATA from 'src/constants/metadata';

// import ScriptC from '../Layout/Script';

interface HeadShareProps extends NextSeoProps {
	pageItem?: any;
}

const HeadShare = (props: HeadShareProps) => {
	const r = useRouter();
	const title = props.title ? props.title : METADATA.APP_NAME;
	const artikelData = props.pageItem;
	const defaultImage = METADATA.IMG_SHARE;
	const defaultImageAuthor = '/images/author/author.png';
	const itemMetaIndex =
		!artikelData && METADATA.WEB_URL === 'http://localhost:8080' ? 'noindex' :
		!artikelData && METADATA.WEB_URL === 'https://stg.hallobumil.com' ? 'noindex' :
		!artikelData && METADATA.WEB_URL === 'https://hallobumil.com' ? 'index' :
		artikelData && r.pathname === '/event/[sub]' && METADATA.WEB_URL === 'https://stg.hallobumil.com' ? 'noindex' :
		artikelData && r.pathname === '/event/[sub]' && METADATA.WEB_URL === 'https://hallobumil.com' ? 'index' :
		artikelData && r.pathname === '/author/[sub]' && METADATA.WEB_URL === 'https://stg.hallobumil.com' ? 'noindex' :
		artikelData && r.pathname === '/author/[sub]' && METADATA.WEB_URL === 'https://hallobumil.com' ? 'index' :
		props?.pageItem?.meta_robot_index === '' && METADATA.WEB_URL === 'http://localhost:8080' ? 'noindex' :
		props?.pageItem?.meta_robot_index === '' && METADATA.WEB_URL === 'https://stg.hallobumil.com' ? 'noindex' :
		props?.pageItem?.meta_robot_index === '' && METADATA.WEB_URL === 'https://hallobumil.com' ? 'index' :
		props?.pageItem?.meta_robot_index;
	const itemMetaFollow =
		!artikelData && METADATA.WEB_URL === 'http://localhost:8080' ? 'nofollow' :
		!artikelData && METADATA.WEB_URL === 'https://stg.hallobumil.com' ? 'nofollow' :
		!artikelData && METADATA.WEB_URL === 'https://hallobumil.com' ? 'follow' :
		artikelData && r.pathname === '/event/[sub]' && METADATA.WEB_URL === 'https://stg.hallobumil.com' ? 'nofollow' :
		artikelData && r.pathname === '/event/[sub]' && METADATA.WEB_URL === 'https://hallobumil.com' ? 'follow' :
		artikelData && r.pathname === '/author/[sub]' && METADATA.WEB_URL === 'https://stg.hallobumil.com' ? 'nofollow' :
		artikelData && r.pathname === '/author/[sub]' && METADATA.WEB_URL === 'https://hallobumil.com' ? 'follow' :
		props?.pageItem?.meta_robot_follow === '' && METADATA.WEB_URL === 'http://localhost:8080' ? 'nofollow' :
		props?.pageItem?.meta_robot_follow === '' && METADATA.WEB_URL === 'https://stg.hallobumil.com' ? 'nofollow' :
		props?.pageItem?.meta_robot_follow === '' && METADATA.WEB_URL === 'https://hallobumil.com' ? 'follow' :
		props?.pageItem?.meta_robot_follow;

	const itemTitle = (props?.pageItem?.meta_title || props.title) as string;
	const itemDescription = (props?.pageItem?.meta_description || props.description) as string;
	const itemImageOri = props?.pageItem?.media_images?.[0]?.original || props?.pageItem?.thumbnail_url || defaultImage;
	const itemImageEvent = props?.pageItem?.image_files?.[0]?.path || defaultImage;
	const itemImageAuthor = props?.pageItem?.media_images?.original || defaultImageAuthor;
	const itemImage = r.pathname === '/author/[sub]' ? itemImageAuthor : r.pathname === '/event/[sub]' ? itemImageEvent :itemImageOri;
	return (
		<>
			{!!props.pageItem ? (
				<NextSeo
					noindex={itemMetaIndex === 'noindex'} // TODO: not return index (next feature)
					nofollow={itemMetaFollow === 'nofollow'} // TODO: not return follow (next feature)
					openGraph={{
						title: itemTitle,
						description: itemDescription,
						images: [{ url: itemImage, alt: `Gambar ${itemTitle}` }],
					}}
					additionalMetaTags={[
						{
							name: 'twitter:card',
							content: 'summary_large_image',
						},
						{
							name: 'twitter:title',
							content: itemTitle,
						},
						{
							name: 'twitter:description',
							content: itemDescription,
						},
						{
							name: 'twitter:image',
							content: itemImage,
						},
						{
							name: 'twitter:url',
							content: METADATA.WEB_URL + r.asPath.split('?')[0],
						},
						{
							name: 'twitter:robots',
							content: `${itemMetaIndex},${itemMetaFollow}`,
						},
						{
							name: 'og:robots',
							content: `${itemMetaIndex},${itemMetaFollow}`,
						},
					]}
					{...props}
				/>
			) : (
				<NextSeo
					noindex={itemMetaIndex === 'noindex'}
					nofollow={itemMetaFollow === 'nofollow'}
					openGraph={{
						title: props.title as string,
						description: props.description as string,
						images: [{ url: itemImage, alt: `Gambar ${itemTitle}` }],
					}}
					additionalMetaTags={[
						{
							name: 'twitter:card',
							content: 'summary_large_image',
						},
						{
							name: 'twitter:title',
							content: props.title as string,
						},
						{
							name: 'twitter:description',
							content: props.description as string,
						},
						{
							name: 'twitter:image',
							content: itemImage,
						},
						{
							name: 'twitter:site',
							content: '@hallobumil_id',
						},
						{
							name: 'twitter:url',
							content: METADATA.WEB_URL + r.asPath.split('?')[0],
						},
					]}
					{...props}
				/>
			)}

			<Head>
				<title>{title}</title>

				{/* NOTE: unique case, we can't set this on component */}
				<meta name="title" content={title} />
				<meta name="viewport" content="width=device-width, initial-scale=1" />
				<meta
					id="meta"
					name="viewport"
					content="width=device-width; initial-scale=1.0; maximum-scale=1.0; user-scalable=0;"
				></meta>
				{/* <ScriptC /> */}
				{artikelData && (
					<>
						<meta name="author" content={artikelData.author_name} />
						<meta name="publisher" content="Hallobumil" />
					</>
				)}
				<meta
					property="og:url"
					content={process.env.NEXT_PUBLIC_WEB_URL + r.asPath.split('?')[0]}
				/>
				<meta property="og:type" content="article" />
				<meta property="og:site_name" content="Hallobumil" />
				<link
					rel="alternate"
					media="only screen and (max-width: 640px)"
					href={process.env.NEXT_PUBLIC_WEB_URL + r.asPath.split('?')[0]}
				/>
				<link
					rel="alternate"
					media="handheld"
					href={process.env.NEXT_PUBLIC_WEB_URL + r.asPath.split('?')[0]}
				/>
				<link rel="canonical" href={!artikelData?.canonical_url ? process.env.NEXT_PUBLIC_WEB_URL + r.asPath.split('?')[0] : process.env.NEXT_PUBLIC_WEB_URL +'/'+ artikelData?.canonical_url} />
				{/* <link rel="preload" href={`https://www.googletagmanager.com/gtm.js?id=${process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER}`}/> */}
			</Head>
		</>
	);
};

export default HeadShare;
